import { render } from "./AddAddessForm.vue?vue&type=template&id=8ecef136"
import script from "./AddAddessForm.vue?vue&type=script&lang=js"
export * from "./AddAddessForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__